(() => {
  const root = document.documentElement;
  root.classList.add('ag-olfacto-collection-page');

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const alternateView = new URL(window.location.href).searchParams.get('view');

  const initRail = (rail) => {
    if (!rail || rail.dataset.agRailReady === 'true') return;

    rail.dataset.agRailReady = 'true';
    const section = rail.closest('.ag-olfacto-collection-categories');
    const cue = section?.querySelector('[data-ag-category-cue]');

    const dismissCue = () => cue?.classList.add('is-dismissed');
    rail.addEventListener('scroll', dismissCue, { once: true, passive: true });
    rail.addEventListener('pointerdown', dismissCue, { once: true, passive: true });
    rail.addEventListener('keydown', dismissCue, { once: true });
  };

  const initReveals = () => {
    const sections = [...document.querySelectorAll('[data-ag-collection-reveal]')];
    if (!sections.length) return;

    if (prefersReducedMotion.matches || !('IntersectionObserver' in window)) {
      sections.forEach((section) => section.classList.add('is-visible'));
      return;
    }

    root.classList.add('ag-collection-motion-ready');
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -6% 0px' }
    );

    sections.forEach((section) => observer.observe(section));
  };

  const initAnchors = () => {
    document.querySelectorAll('a[href="#ProductGridContainer"]').forEach((link) => {
      if (link.dataset.agAnchorReady === 'true') return;
      link.dataset.agAnchorReady = 'true';
      link.addEventListener('click', (event) => {
        const target = document.querySelector('#ProductGridContainer');
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({
          behavior: prefersReducedMotion.matches ? 'auto' : 'smooth',
          block: 'start'
        });
        const nextUrl = new URL(window.location.href);
        nextUrl.hash = 'ProductGridContainer';
        history.replaceState(null, '', `${nextUrl.pathname}${nextUrl.search}${nextUrl.hash}`);
      });
    });
  };

  const preserveAlternateView = () => {
    if (!alternateView) return;

    document
      .querySelectorAll('#main-collection-filters form, facet-filters-form form')
      .forEach((form) => {
        let input = form.querySelector('input[name="view"]');
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'view';
          input.dataset.agViewPreserver = 'true';
          form.append(input);
        }
        input.value = alternateView;
      });

    document
      .querySelectorAll('#main-collection-filters a[href], #ProductGridContainer .pagination-wrapper a[href]')
      .forEach((link) => {
        const target = new URL(link.href, window.location.href);
        if (target.origin !== window.location.origin || target.pathname !== window.location.pathname) return;
        target.searchParams.set('view', alternateView);
        link.href = target.toString();
      });
  };

  const init = () => {
    document.querySelectorAll('[data-ag-category-rail]').forEach(initRail);
    initAnchors();
    initReveals();
    preserveAlternateView();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);

  if (alternateView) {
    let syncFrame;
    const observer = new MutationObserver(() => {
      if (syncFrame) return;
      syncFrame = window.requestAnimationFrame(() => {
        syncFrame = null;
        preserveAlternateView();
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
})();
